import * as React from "react";
import { attributeMap } from "source/app/presentation/MainPanel/Dreams/DreamAttributeIcon/AttributeMap/AttributeMap";
import Cell from "../Cell/Cell";
import { GetAttributeIcon } from "./GetAttributeIcon";
import IDream from "motw_core/Entity/IDream";

export function DreamAttributeIconBasic({
    attribute,
    dream,
}: {
    attribute: string;
    dream?: IDream;
}) {
    const attributeIcon = GetAttributeIcon(attribute, attributeMap, dream);

    return (
        <span>
            <Cell>
                <span>{attributeIcon}</span>
            </Cell>
        </span>
    );
}
